import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import {
  getFirestore,
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getMessaging, isSupported as isMessagingSupported } from 'firebase/messaging';

import { env } from './env.js';
import { initAppCheck } from './app-check.js';

export const firebaseApp = initializeApp(env.firebase);
initAppCheck(firebaseApp);

/** Firestore with offline persistence (multi-tab safe). */
export const db = initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});

export const auth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);
export const functions = getFunctions(firebaseApp, 'asia-southeast1');

/** FCM — null where the browser has no Web Push (operator push, lib/push/client.ts). */
export const messaging = (async () => {
  if (!(await isMessagingSupported())) return null;
  return getMessaging(firebaseApp);
})();

if (env.useEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}

// Keep the unused-import lint happy while we wire features in Phase 1.
void getFirestore;
